export default {
  read: (value: string) => {
    if (value === 'undefined') return undefined
    if (value === 'null') return null
    return value
  },
  write: (value: any) => String(value),
}
